@if (meddata$) {
	<medical-data-list [data]="meddata$ | async" (selectMedicalData)="details.next($event)" />
}
